import React from 'react';

export const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative z-10 bg-dark-lighter border-t border-gray-800 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <p className="text-gray-400">
            &copy; {currentYear} Fwoozie. All rights reserved.
          </p>
          <p className="text-gray-500 text-sm mt-2">
            The Future is Now
          </p>
        </div>
      </div>
    </footer>
  );
};
